<template>
  <header>
    <div class="logos">
      <a href="https://www.covve.com" class="covve-logo" target="_blank"
        ><img src="@/assets/covve-logo.svg" alt="Covve Logo"
      /></a>
      <div class="play-and-win">
        <img
          src="@/assets/play-and-win-retro-text.png"
          alt="Play And Win - A classic game of snake"
        />
      </div>
      <div class="hack" style="width: 78px"></div>
    </div>
  </header>
</template>

<script>
import Timers from "@/components/TimersV2";
export default {
  components: { Timers },
  props: ["expiresOn"]
};
</script>

<style lang="scss">
header {
  max-width: 1170px;
  margin: 0 auto;
  margin-bottom: 30px;
  position: relative;
  .logos {
    display: flex;
    justify-content: space-between;
    padding: 10px 45px;
    .covve-logo {
      box-shadow: none;
    }
  }
  .play-and-win {
    // pointer-events: none;
    // position: relative;
    text-align: center;
    margin-top: -25px;
    img {
      max-height: none !important;
    }
    // top: -75px;
    // margin-bottom: 150px;
    margin-bottom: -50px;
  }
}

@media (max-width: 768px) {
  header {
    padding-top: 10px;
    .logos {
      padding: 10px 20px;
      // display: block;
      .hack {
        display: none;
      }
      padding: 0px 35px;
      img {
        max-height: 60px;
        min-width: 45px;
      }
    }
    .play-and-win {
      top: 0;
      margin: 0;
    }
  }
}
</style>